import { createContext, useContext, useEffect, useReducer, useState } from 'react';

const initialState = { 
    settingsOpen: false,
    settingTitle: '',
    settingCode: '',
    currentNotify: null,
    settingData: null,
    sweetDialogInfo: null,
};

const reducer = (state, action) => {
    switch (action.type) {
      case 'CLEAR':
        return { initialState};  // Reset state completely
      default:
        return {...state, [action.type]: action.payload};
    }
};


const UIContext = createContext();

export const UIProvider = ({children}) =>{
  const [state, dispatch] = useReducer(reducer, initialState);
  const [sidebarHidden, setSidebarHidden] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showSubmenu, setShowSubmenu] = useState(null);
  
  useEffect(()=>{
    if(state.currentNotify){
        setTimeout(() => {
            setNotify(null);
        }, 9000);
    }
  }, [state.currentNotify])

 

  // Handle window resize to toggle between hide/show behavior
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        // Desktop behavior
        document.body.classList.toggle('main-sidebar-hide', sidebarHidden);
        document.body.classList.remove('main-sidebar-show', 'main-sidebar-open');
      } else {
        // Mobile behavior
        document.body.classList.toggle('main-sidebar-show', sidebarOpen);
        document.body.classList.remove('main-sidebar-hide');
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [sidebarHidden, sidebarOpen]);

  const toggleSidebar = () => {
    if (window.innerWidth >= 768) {
      setSidebarHidden(!sidebarHidden);
    } else {
      setSidebarOpen(!sidebarOpen);
    }
  };

  const handleSubmenuToggle = (index) => {
    setShowSubmenu(showSubmenu === index ? null : index);
  };

  const openSettings = (title, code, data)=>{
    dispatch({type: 'settingsOpen', payload: true});
    dispatch({type: 'settingTitle', payload: title});
    dispatch({type: 'settingCode', payload: code});
    dispatch({type: 'settingData', payload: data});

  }
 
  const closeSettings = ()=>{
    dispatch({type: 'settingsOpen', payload: false})
    dispatch({type: 'settingCode', payload: null})
  }

  const setNotify = (notify) =>{
    dispatch({type: 'currentNotify', payload: notify})
  }

  const setSweetDialogInfo = (title, subtitle) =>{
    dispatch({type: 'sweetDialogInfo', payload: {title: title, subtitle: subtitle}})
  }
  const clearSweetDialogInfo = () =>{
    dispatch({type: 'sweetDialogInfo', payload: null})
  }
  return(
    <UIContext.Provider value={{
      ...state,
      sidebarOpen,
      showSubmenu,
      sidebarHidden,
      toggleSidebar,
      handleSubmenuToggle,
      dispatch,
      openSettings,
      closeSettings,
      setNotify,
      setSweetDialogInfo,
      clearSweetDialogInfo, 
      }}>
      {children}
    </UIContext.Provider>
  )

}

export const useUI = ()=>useContext(UIContext);

